const RemoveIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
    >
      <path
        d="M21.4678 5.97998C18.1378 5.64998 14.7878 5.47998 11.4478 5.47998C9.46777 5.47998 7.48777 5.57998 5.50777 5.77998L3.46777 5.97998"
        stroke="#7A7A7A"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.96777 4.97L9.18777 3.66C9.34777 2.71 9.46777 2 11.1578 2H13.7778C15.4678 2 15.5978 2.75 15.7478 3.67L15.9678 4.97"
        stroke="#7A7A7A"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.3182 9.13989L18.6682 19.2099C18.5582 20.7799 18.4682 21.9999 15.6782 21.9999H9.25816C6.46816 21.9999 6.37816 20.7799 6.26816 19.2099L5.61816 9.13989"
        stroke="#7A7A7A"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.7979 16.5H14.1279"
        stroke="#7A7A7A"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.96777 12.5H14.9678"
        stroke="#7A7A7A"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default RemoveIcon;